const DLLG01V101 = async () => await import('@/views/dllg/DLLG-01-V101.vue')

export const routerDllg = [
  {
    path: '/dllg/DLLG-01-V101',
    component: DLLG01V101,
    name: 'DLLG-01-V101',
    meta: {
      title: '로그인',
      code: 'DLLG-01-V101',
      tabName: '로그인'
    }
  }
]
